import React from 'react';
import t from 'prop-types';
import * as HERRAMIENTA from './constantes';
import BotonGrosorColor from './boton-grosor-color';

function BotonLapiz(_ref) {
  var seleccionado = _ref.seleccionado,
      onPresionado = _ref.onPresionado,
      colores = _ref.colores,
      grosores = _ref.grosores,
      colorSeleccionado = _ref.colorSeleccionado,
      grosorSeleccionado = _ref.grosorSeleccionado;
  return React.createElement(BotonGrosorColor, {
    herramientaId: HERRAMIENTA.LAPIZ_ID,
    seleccionado: seleccionado,
    onPresionado: onPresionado,
    herramientaGrosorId: HERRAMIENTA.LAPIZ_GROSOR_ID,
    grosores: grosores,
    grosorSeleccionado: grosorSeleccionado,
    herramientaColorId: HERRAMIENTA.LAPIZ_COLOR_ID,
    colores: colores,
    colorSeleccionado: colorSeleccionado
  });
}

BotonLapiz.propTypes = process.env.NODE_ENV !== "production" ? {
  /** lista de colores */
  colores: t.arrayOf(t.string),

  /** 
   * color inicialmente seleccionado, debe existir en la lista de colores,
   * por defecto, el primero de la lista
   * 
   * */
  colorSeleccionado: t.string,

  /** lista de grosores */
  grosores: t.arrayOf(t.number),

  /** 
   * grosor inicialmente seleccionado, debe existir en la lista de grosores,
   * por defecto, el primero de la lista
   */
  grosorSeleccionado: t.number,
  seleccionado: t.bool,
  onPresionado: t.func
} : {};
BotonLapiz.defaultProps = {
  colores: HERRAMIENTA.COLORES_LAPIZ_POR_DEFECTO,
  grosores: HERRAMIENTA.GROSORES_LAPIZ_POR_DEFECTO
};
export default BotonLapiz;